import { useMemo } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { queryStringParser } from "../../utils";

function useRouter() {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  // Return our custom router object
  // Memoize so that a new object is only returned if something changes
  return useMemo(
    () => ({
      // For convenience add push(), replace(), pathname at top level
      go: navigate,
      // replace: history.replace,
      pathname: location.pathname,
      // Merge params and parsed query string into single "query" object
      // so that they can be used interchangeably.
      // Example: /:topic?sort=popular -> { topic: "react", sort: "popular" }
      query: {
        // TODO: Add types
        ...queryStringParser(location.search), // Convert string to object
        ...params,
      },
      // Include match, location, history objects so we have
      // access to extra React Router functionality if needed.
      // match,
      location,
      history: window.history ? window.history : null,
    }),
    [params, location, window.history],
  );
}
export default useRouter;
